function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3.4 13c-.33 0-.613-.118-.848-.353A1.153 1.153 0 012.2 11.8V2.2c0-.33.118-.613.353-.848S3.07 1 3.4 1h4.8l3.6 3.6v7.2c0 .33-.118.613-.353.848A1.153 1.153 0 0110.6 13H3.4zm4.2-7.8h3l-3-3v3z",
  fill: "currentColor"
});

var SvgDraft = function SvgDraft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none"
  }, props), _ref);
};

export default SvgDraft;